module.exports = __webpack_public_path__ + "img/image1.4b394fb1.jpeg";